var TaskListItemType;
(function (TaskListItemType) {
    TaskListItemType["QUESTIONNAIRE"] = "QT";
    TaskListItemType["PROFILE_UPDATE"] = "AP";
    TaskListItemType["CONSENT_FORM"] = "TC";
    TaskListItemType["INSTITUTIONAL_MATERIAL"] = "MI";
    TaskListItemType["UPLOAD_FILE"] = "CA";
    TaskListItemType["ASK_THE_PHYSICIAN"] = "PM";
    TaskListItemType["SATISFACTION_SURVEY"] = "PS";
    TaskListItemType["GUIDANCE_TO_THE_PATIENT"] = "OP";
})(TaskListItemType || (TaskListItemType = {}));
export default TaskListItemType;
//# sourceMappingURL=task-list-item-type.js.map